import React, { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import { Box, Grid, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import adimg from "../../../../assets/images/adimg.png";
import zcoin from "../../../../assets/images/zcoin.png";
import Mountain from "../../../../assets/images/Mountain.png";
import Cloudstop from "../../../../assets/images/Cloudstop.png";
import Cloudsbottom from "../../../../assets/images/Cloudsbottom.png";

const CONTRACT_ADDRESS = "HKjrNpoTZC6Q1gdJruVYtwfCbRBFRZgZWRNqDamTxbNa";

const SNOW_FLAKES = [
  { left: 3, size: 18, delay: -2, duration: 10, drift: -34, opacity: 0.9 },
  { left: 7, size: 11, delay: -7, duration: 8, drift: 24, opacity: 0.82 },
  { left: 12, size: 26, delay: -8, duration: 14, drift: 42, opacity: 0.95 },
  { left: 17, size: 15, delay: -4, duration: 9, drift: -22, opacity: 0.86 },
  { left: 22, size: 21, delay: -13, duration: 15, drift: 48, opacity: 0.92 },
  { left: 27, size: 13, delay: -1, duration: 11, drift: -28, opacity: 0.84 },
  { left: 32, size: 29, delay: -6, duration: 12, drift: -44, opacity: 0.98 },
  { left: 37, size: 16, delay: -10, duration: 9, drift: 32, opacity: 0.88 },
  { left: 42, size: 23, delay: -3, duration: 16, drift: -52, opacity: 0.93 },
  { left: 47, size: 12, delay: -12, duration: 8, drift: 26, opacity: 0.82 },
  { left: 52, size: 24, delay: -5, duration: 13, drift: -46, opacity: 0.94 },
  { left: 57, size: 14, delay: -15, duration: 10, drift: 34, opacity: 0.86 },
  { left: 62, size: 20, delay: -9, duration: 12, drift: 30, opacity: 0.9 },
  { left: 37, size: 16, delay: -10, duration: 9, drift: 32, opacity: 0.88 },
  { left: 42, size: 23, delay: -3, duration: 16, drift: -52, opacity: 0.93 },
  { left: 47, size: 12, delay: -12, duration: 8, drift: 26, opacity: 0.82 },
  { left: 52, size: 24, delay: -5, duration: 13, drift: -46, opacity: 0.94 },
  { left: 57, size: 14, delay: -15, duration: 10, drift: 34, opacity: 0.86 },
  { left: 62, size: 20, delay: -9, duration: 12, drift: 30, opacity: 0.9 },
  { left: 67, size: 28, delay: -14, duration: 17, drift: -40, opacity: 0.96 },
  { left: 72, size: 13, delay: -11, duration: 8, drift: 22, opacity: 0.84 },
  { left: 77, size: 22, delay: -1, duration: 11, drift: 38, opacity: 0.92 },
  { left: 82, size: 16, delay: -6, duration: 10, drift: -30, opacity: 0.88 },
  { left: 86, size: 25, delay: -12, duration: 15, drift: -36, opacity: 0.95 },
  { left: 91, size: 12, delay: -4, duration: 9, drift: 26, opacity: 0.82 },
  { left: 96, size: 19, delay: -8, duration: 12, drift: -24, opacity: 0.9 },
  { left: 15, size: 10, delay: -16, duration: 7, drift: 18, opacity: 0.8 },
  { left: 45, size: 18, delay: -18, duration: 10, drift: 44, opacity: 0.9 },
  { left: 64, size: 11, delay: -19, duration: 8, drift: -18, opacity: 0.8 },
  { left: 89, size: 27, delay: -17, duration: 16, drift: 46, opacity: 0.96 },
  { left: 9, size: 14, delay: -20, duration: 9, drift: -20, opacity: 0.86 },
{ left: 24, size: 17, delay: -22, duration: 11, drift: 28, opacity: 0.9 },
{ left: 39, size: 12, delay: -21, duration: 8, drift: -18, opacity: 0.82 },
{ left: 58, size: 20, delay: -23, duration: 13, drift: 34, opacity: 0.92 },
{ left: 74, size: 15, delay: -24, duration: 10, drift: -26, opacity: 0.88 },
{ left: 93, size: 18, delay: -25, duration: 12, drift: 22, opacity: 0.9 },
{ left: 9, size: 14, delay: -20, duration: 9, drift: -20, opacity: 0.86 },
{ left: 24, size: 17, delay: -22, duration: 11, drift: 28, opacity: 0.9 },
{ left: 39, size: 12, delay: -21, duration: 8, drift: -18, opacity: 0.82 },
{ left: 58, size: 20, delay: -23, duration: 13, drift: 34, opacity: 0.92 },
{ left: 74, size: 15, delay: -24, duration: 10, drift: -26, opacity: 0.88 },
{ left: 93, size: 18, delay: -25, duration: 12, drift: 22, opacity: 0.9 },
];

const Wrapper = styled.section`
  width: 100%;
  background: #fff;
  position: relative;
  overflow: hidden;
  /* min-height: 650px; */
  padding: 170px 0px;

  @media (max-width: 768px) {
    padding: 120px 0px 150px;
    overflow-x: clip;
    overflow-y: visible;
  }
`;

const Inner = styled.div`
  width: 100%;
      max-width: 1100px;
  margin: 0 auto;
  position: relative;
  /* aspect-ratio: 2064 / 1324; */
  min-height: 560px;

  @media (max-width: 768px) {
    aspect-ratio: auto;
    min-height: 860px;
  }
`;

const BgImage = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  background-image: url(${adimg});
  /* background-size: min(1120px, 100vw) auto; */
  /* background-position: center; */
  background-repeat: no-repeat;
  z-index: 0;

  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileMountain = styled.img`
  display: none;

  @media (max-width: 768px) {
    display: block;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    z-index: 0;
    pointer-events: none;
    user-select: none;
  }
`;

const MobileCloudTop = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    position: sticky;
    top: 72px;
    height: 0;
    z-index: 3;
    pointer-events: none;
    user-select: none;

    &::before {
      content: "";
      position: absolute;
      left: 50%;
      top: -85px;
      width: max(900px, 120vw);
      height: 215px;
      max-width: none;
      transform: translateX(-50%);
      background-image: url(${Cloudstop});
      background-size: 100% auto;
      background-position: center top;
      background-repeat: no-repeat;
    }
  }

  @media (max-width: 480px) {
    top: 10px;

    &::before {
      top: -40px;
      width: max(820px, 245vw);
      height: 205px;
    }
  }
`;

const MobileCloudBottom = styled.img`
  display: none;

  @media (max-width: 768px) {
    display: block;
    position: absolute;
    left: 50%;
    bottom: -75px;
    width: 100%;
    max-width: 500px;
    transform: translateX(-50%);
    z-index: 3;
    pointer-events: none;
    user-select: none;
  }

  @media (max-width: 480px) {
    width: max(820px, 245vw);
        bottom: -50px;
  }
`;

const SnowLayer = styled.div`
  position: absolute;
  inset: 70px 0 90px;
  z-index: 1;
  pointer-events: none;
  user-select: none;
  overflow: hidden;
  opacity: 0.95;
  -webkit-mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    #000 14%,
    #000 84%,
    transparent 100%
  );
  mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    #000 14%,
    #000 84%,
    transparent 100%
  );

  @media (max-width: 768px) {
    inset: 55px 0 80px;
  }

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`;

const SnowFlake = styled("span", {
  shouldForwardProp: (prop) =>
    !["left", "size", "delay", "duration", "drift", "opacity"].includes(prop),
})`
  position: absolute;
  top: -34px;
  left: ${(props) => props.left}%;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  opacity: ${(props) => props.opacity};
  filter:
    drop-shadow(0 0 7px rgba(255, 255, 255, 1))
    drop-shadow(0 3px 8px rgba(57, 133, 188, 0.45));
  animation: snowFall ${(props) => props.duration}s linear infinite;
  animation-delay: ${(props) => props.delay}s;

  &::before,
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 999px;
    background:
      radial-gradient(circle, #ffffff 0 18%, transparent 19%),
      linear-gradient(#fff, #fff) 50% 0 / 18% 100% no-repeat,
      linear-gradient(90deg, #fff, #fff) 0 50% / 100% 18% no-repeat;
  }

  &::after {
    transform: rotate(45deg);
  }

  @keyframes snowFall {
    0% {
      top: -60px;
      transform: translate3d(0, 0, 0) rotate(0deg);
    }

    50% {
      top: 50%;
      transform: translate3d(${(props) => props.drift}px, 0, 0) rotate(180deg);
    }

    100% {
      top: calc(100% + 60px);
      transform: translate3d(${(props) => props.drift * -0.45}px, 0, 0) rotate(360deg);
    }
  }

  @media (max-width: 768px) {
    width: ${(props) => Math.max(7, props.size - 3)}px;
    height: ${(props) => Math.max(7, props.size - 3)}px;
  }
`;

const ContentGrid = styled(Grid)`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding-top: 180px;

  @media (max-width: 900px) {
    width: min(760px, 86%);
    padding-top: 150px;
  }

  @media (max-width: 768px) {
    width: min(520px, 92%);
    padding-top: 130px;
    z-index: 2;
  }
`;

const BrowseCard = styled.div`
  height: 100%;
  min-height: 300px;
  border-radius: 8px;
  padding: 24px 26px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1920' height='625' viewBox='0 0 1920 625' fill='none'%3E%3CforeignObject x='-31.8' y='-31.8' width='1983.6' height='688.197'%3E%3Cdiv xmlns='http://www.w3.org/1999/xhtml' style='backdrop-filter:blur(15.9px);clip-path:url(%23bgblur_0_1_14_clip_path);height:100%25;width:100%25'%3E%3C/div%3E%3C/foreignObject%3E%3Cg filter='url(%23filter0_n_1_14)' data-figma-bg-blur-radius='31.8'%3E%3Crect width='1920' height='624.597' fill='url(%23paint0_linear_1_14)' fill-opacity='0.5'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_n_1_14' x='-31.8' y='-31.8' width='1983.6' height='688.197' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeTurbulence type='fractalNoise' baseFrequency='2 2' stitchTiles='stitch' numOctaves='3' result='noise' seed='5857'/%3E%3CfeColorMatrix in='noise' type='luminanceToAlpha' result='alphaNoise'/%3E%3CfeComponentTransfer in='alphaNoise' result='coloredNoise1'%3E%3CfeFuncA type='discrete' tableValues='1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 '/%3E%3C/feComponentTransfer%3E%3CfeComposite operator='in' in2='shape' in='coloredNoise1' result='noise1Clipped'/%3E%3CfeFlood flood-color='rgba(255, 255, 255, 0.25)' result='color1Flood'/%3E%3CfeComposite operator='in' in2='noise1Clipped' in='color1Flood' result='color1'/%3E%3CfeMerge result='effect1_noise_1_14'%3E%3CfeMergeNode in='shape'/%3E%3CfeMergeNode in='color1'/%3E%3C/feMerge%3E%3C/filter%3E%3CclipPath id='bgblur_0_1_14_clip_path' transform='translate(31.8 31.8)'%3E%3Crect width='1920' height='624.597'/%3E%3C/clipPath%3E%3ClinearGradient id='paint0_linear_1_14' x1='960' y1='0' x2='960' y2='624.597' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D9D8D8'/%3E%3Cstop offset='1' stop-color='white'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");

  backdrop-filter: blur(15.9px);
  -webkit-backdrop-filter: blur(15.9px);
  @media (max-width: 768px) {
    min-height: 150px;
    padding: 24px;
  }
`;

const BottomCard = styled(BrowseCard)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 350px;
  padding: 24px 32px;
  overflow: hidden;

  &::after {
  content: "";
    position: absolute;
    left: 0%;
    right: -8%;
    bottom: -66px;
    height: 170px;
    z-index: 2;
    pointer-events: none;
    background:
      radial-gradient(ellipse at 22% 42%, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.82) 34%, rgba(255, 255, 255, 0) 68%),
      radial-gradient(ellipse at 64% 34%, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.72) 32%, rgba(255, 255, 255, 0) 70%),
      radial-gradient(ellipse at 90% 48%, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.78) 36%, rgba(255, 255, 255, 0) 72%),
      linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #fff 62%, #fff 100%);
    filter: blur(10px);
  }

  @media (max-width: 768px) {
    min-height: 230px;

    &::after {
      bottom: -45px;
      height: 130px;
    }
  }
`;

const CardTitle = styled(Typography)`
  color: #000;
  font-size: 24px;
  line-height: 1.12;
  font-family: "primary1" !important;
  margin-bottom: 18px;

  @media (max-width: 520px) {
    font-size: 20px;
    margin-bottom: 12px;
  }
`;

const CardText = styled(Typography)`
  color: #000;
  font-size: 20px;
  line-height: 1.25;
  /* max-width: 410px; */

  @media (max-width: 520px) {
    font-size: 13px;
  }
`;
const CardContent = styled.div`
  flex: 1;
  max-width: 520px;
`;
const CardContentbottom = styled.div`
  flex: 1;
  max-width: 520px;
  margin-top: -10px;
  position: relative;
  z-index: 3;
   @media (max-width: 800px) {
    margin-top: 0px;
  }
`;

const CoinImage = styled.img`
  width: 100%;
  max-width: 350px;
  object-fit: contain;
  margin-left: 32px;
  margin-right: 24px;
  align-self: center;
  flex-shrink: 0;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    width: 150px;
    height: 130px;
  }
`;

const CaBadge = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 16px;
  background: #1a1a1a;
  border-radius: 9px;
  border: 0;
  padding: 6px 12px;
  font-size: 12px;
  color: #fff;
  font-weight: 500;
  cursor: pointer;

  svg {
    width: 13px;
    height: 13px;
    opacity: 0.78;
  }
`;

const TbaBadge = styled.span`
  /* background: rgba(255, 255, 255, 0.15); */
  border-radius: 12px;
  padding: 2px 8px;
  color: #ccc;
  font-size: 11px;
`;

const CopyToast = styled("div", {
  shouldForwardProp: (prop) => prop !== "show",
})`
  position: absolute;
  left: 32px;
  bottom: 28px;
  z-index: 4;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgba(26, 26, 26, 0.92);
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  opacity: ${(props) => (props.show ? 1 : 0)};
  transform: translateY(${(props) => (props.show ? "0" : "8px")});
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;

  @media (max-width: 768px) {
    left: 24px;
    bottom: 20px;
  }
`;

const BlurOverlay = styled(Box)`
  position: absolute;
  bottom: -10px;
  width: 100%;
  height: 30%; 
  background: linear-gradient(
    to bottom,
    rgba(245, 245, 245, 0) 0%,    
    rgb(255, 255, 255) 50%,
    #ffffff 100%                 
  );
  z-index: 1;

  @media (max-width: 1024px) {
    height: 18%;
    background: linear-gradient(
      to bottom,
      rgba(245, 245, 245, 0) 0%,
      rgba(245, 245, 245, 0.364) 70%,
      #f5f5f5 100%
    );
  }

  @media (max-width: 768px) {
    height: 16%;
  }

  @media (max-width: 480px) {
    height: 14%;
  }
`;
const Adblocker = () => {
  const [showCopyToast, setShowCopyToast] = useState(false);
  const copyToastTimer = useRef(null);

  useEffect(() => {
    return () => {
      if (copyToastTimer.current) {
        clearTimeout(copyToastTimer.current);
      }
    };
  }, []);

  const handleCopyAddress = async () => {
    try {
      await navigator.clipboard?.writeText(CONTRACT_ADDRESS);
    } finally {
      setShowCopyToast(true);
      if (copyToastTimer.current) {
        clearTimeout(copyToastTimer.current);
      }
      copyToastTimer.current = setTimeout(() => {
        setShowCopyToast(false);
      }, 1600);
    }
  };

  return (
    <Wrapper id='ZEP'>
      <BgImage />
      <SnowLayer aria-hidden="true">
        {SNOW_FLAKES.map((flake, index) => (
          <SnowFlake key={index} {...flake} />
        ))}
      </SnowLayer>
      <Inner>
        <MobileMountain src={Mountain} alt="" aria-hidden="true" />
        <MobileCloudTop aria-hidden="true" />
        <MobileCloudBottom src={Cloudsbottom} alt="" aria-hidden="true" />
        <ContentGrid container spacing={2} >
          <Grid item xs={12} md={7} data-aos="fade-up" data-aos-delay="100">
            <BrowseCard>
              <CardTitle>AdBlock</CardTitle>
              <CardText>
                Zephyr's AdBlock feature blocks all intrusive and annoying ads
                by default, enhancing the browsing experience by removing
                disruptions. It automatically prevents video ads on YouTube,
                sponsored posts and sidebar ads on Facebook, and distracting
                banner ads.
              </CardText>
            </BrowseCard>
          </Grid>

          <Grid item xs={12} md={5} data-aos="fade-up" data-aos-delay="100">
            <BrowseCard>
              <CardTitle>Free VPN</CardTitle>
              <CardText>
                Zephyr's VPN encrypts your Internet traffic for added protection
                and privacy. Hide your IP address, mask your location, and
                access your favorite content on the go.
              </CardText>
            </BrowseCard>
          </Grid>

          <Grid item xs={12} data-aos="fade-up" data-aos-delay="100">
            <BottomCard>
              <CardContentbottom>
                <CardTitle>$ZEPHYR Token</CardTitle>
                <CardText style={{ marginBottom: "22px" }}> 
                  Zephyr  is the native utility token of the Zephyr ecosystem.It will power access to premium browser features, future privacy tools, automation capabilities, and ecosystem services as the platform continues to evolve.
                </CardText>
                <CardText>
                  Network
                </CardText>
                <CardText>
                  Solana 
                  </CardText>
                <CaBadge type="button" onClick={handleCopyAddress} aria-label="Copy contract address">
                  CA: <TbaBadge>{CONTRACT_ADDRESS}</TbaBadge>
                  <ContentCopyIcon />
                </CaBadge>
                <CopyToast show={showCopyToast}>Copied</CopyToast>
              </CardContentbottom>
              <CoinImage src={zcoin} alt="ZEP Coin" />
            </BottomCard>
               {/* <BlurOverlay /> */}
          </Grid>
        </ContentGrid>
</Inner>
    </Wrapper>
  );
};

export default Adblocker;
